import React from "react";

const FlexSpaceBetween = ({
  children,
  column,
  margin = "0.3em 0",
  justify = "space-between",
  align = "flex-start",
  style = {},
}) => {
  return (
    <div
      style={{
        margin,
        width: "100%",
        display: "flex",
        justifyContent: justify,
        flexDirection: column ? "column" : "row",
        alignItems: align,
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default FlexSpaceBetween;
